import React, { useRef, useContext, useState, useEffect } from 'react';
import log from 'loglevel';
import { trimEnd } from 'lodash';
import { Context, usePlayerContext } from '../Context';
import ControlButton from './ControlButton';
import ControlIcon from './ControlIcon';
import { Events } from '../../types/player';
import { useTranslation } from 'react-i18next';

const ControlMenu = ({
  icon,
  controlClassName,
  title,
  content,
}: {
  icon: any;
  controlClassName: string;
  title: string;
  content: any;
}) => {
  const { t } = useTranslation();

  const menuRef = useRef<HTMLDivElement | null>(null);
  const { sdk } = usePlayerContext();
  const [open, setOpen] = useState<boolean>(false);
  const [openSubMenu, setOpenSubMenu] = useState<boolean>(false);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    sdk.on(Events.TOGGLE_CONTROL_MENU, (control: string) => {
      if (control != controlClassName) return;
      if (control == 'sub-menu') {
        setOpenSubMenu(!openSubMenu);
      }
      setOpen(!open);
    });

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open, openSubMenu]);

  const toggleSettings = () => {
    //console.log('toggleControlMenu from toggleSettings', controlClassName);
    sdk.toggleControlMenu(controlClassName);
  };

  const handleClickOutside = (e: MouseEvent) => {
    //console.log('CLICK OUTSIDE', open, menuRef.current, title);
    if (!open || !menuRef.current) {
      return;
    }
    if (!menuRef.current.contains(e.target as Node)) {
      /*console.log(
        'toggleControlMenu from handleClickOutside',
        controlClassName,
      );*/
      sdk.toggleControlMenu(controlClassName);
    }
  };

  //console.log('MMMMMMMMMMMMMMENU ', title, open);
  return (
    <div
      ref={menuRef}
      className={`${sdk.getClassNamePrefix()}-player-control ${sdk.getClassNamePrefix()}-player-control-${controlClassName} ${open ? sdk.getClassNamePrefix() + '-player-control-menu-open' : ''}`}
    >
      <ControlButton
        className={controlClassName}
        handleAction={toggleSettings}
        icon={icon}
        title={title}
      />
      <div
        className={`${sdk.getClassNamePrefix()}-player-control-menu ${sdk.getClassNamePrefix()}-player-control-${controlClassName}-menu`}
      >
        <div
          className={`${sdk.getClassNamePrefix()}-player-control-menu-inner ${sdk.getClassNamePrefix()}-player-control-${controlClassName}-menu-inner`}
        >
          {controlClassName !== 'sub-menu' && (
            <div
              className={`${sdk.getClassNamePrefix()}-player-control-menu-title ${sdk.getClassNamePrefix()}-player-control-menu-title-${controlClassName}`}
              onClick={() => {
                //console.log('toggleControlMenu from icone', controlClassName);
                sdk.toggleControlMenu(controlClassName);
              }}
              role="button"
              onKeyDown={() => {}}
              //tabIndex={0}
            >
              <span
                className={`${sdk.getClassNamePrefix()}-player-control-menu-back`}
              >
                <ControlIcon iconName={'chevronLeft'} />
              </span>{' '}
              {t(title)}
            </div>
          )}
          {content}
        </div>
      </div>
    </div>
  );
};

export default ControlMenu;
